import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";
import View from "./view";

const states = [
  {
    name: "app.not-found",
    url: "/nao-encontrado",
    views: {
      "content@app": View,
      "sidebar@app": Sidebar,
      "topbar@app": Topbar
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/not-found/index.js